import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

interface AutoHeightTransitionProps {
    children: React.ReactNode;
    durationMs?: number;
    easing?: string;
}

const AutoHeightTransition: React.FC<AutoHeightTransitionProps> = ({
    children,
    durationMs = 300,
    easing = 'ease',
}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [heightPx, setHeightPx] = useState<number>(0);

    useEffect(() => {
        const contentEl = contentRef.current;
        if (!contentEl) return;

        setHeightPx(contentEl.scrollHeight);

        const observer = new ResizeObserver(() => {
            setHeightPx(contentEl.scrollHeight);
        });
        observer.observe(contentEl);

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <Box
            ref={containerRef}
            sx={{
                width: '100%',
                overflow: 'hidden',
                height: `${heightPx}px`,
                transition: `height ${durationMs}ms ${easing}`,
            }}
        >
            <Box ref={contentRef} sx={{ width: '100%' }}>
                {children}
            </Box>
        </Box>
    );
};

export default AutoHeightTransition;
